import en from './en/en.json'
import fr from './fr/fr.json'

/**
 * Translations of some texts stored in a json
 */
export const messages: any = {
    en,
    fr
}

/**
 * Languages supported by the app
 */
export const validLocalesArray = ['en', 'fr']

/**
 * 
 * @param language Code of a language (fr, en, en-us etc...)
 * @returns If it's a valid locale
 */
export function isValidLocale(language: string): language is validLocale {
    return validLocalesArray.includes(language.split('-')[0])
}

/**
 * Languages supported by the app
 */
export type validLocale = 'en' | 'fr'
